import { LineHeight } from '@tiptap/extension-text-style';
import { menuControlFor, activeMenuControlFor } from './_get_menu_control';

const syncMenu = ({ editor }) => {
  const lineHeight = editor.getAttributes('textStyle').lineHeight;

  const previousControl = activeMenuControlFor(editor, 'line:height:set');
  const currentControl = menuControlFor(editor, 'line:height:set', lineHeight);

  if (previousControl !== currentControl) {
    previousControl?.classList?.toggle('active', false);
    currentControl?.classList?.toggle('active', true);
  }
};

export default [
  LineHeight.extend({
    onCreate: syncMenu,
    onSelectionUpdate: syncMenu,
    onTransaction: syncMenu,
  }),
];
